'use client';
import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  IconButton,
  Button,
  useColorMode,
  Avatar,
  Box,
  CloseButton,
  Flex,
  HStack,
  VStack,
  Icon,
  useColorModeValue,
  Text,
  Drawer,
  DrawerContent,
  useDisclosure,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Image,
} from '@chakra-ui/react';
import { useAuth } from './AuthContext';
import { Link as RouterLink } from 'react-router-dom'; // Import RouterLink from react-router-dom
import {
  FiHome,
  FiTrendingUp,
  FiCompass,
  FiStar,
  FiSettings,
  FiMenu,
  FiUpload,
  FiFilm,
  FiChevronDown,
} from 'react-icons/fi';
import { FaFontAwesome, FaMoon, FaSun } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { ChakraProvider } from '@chakra-ui/react';
import customTheme from './theme'; // Import your custom theme
// Array of link items with name and icon
const LinkItems = [
  { name: 'Home', icon: FiHome, href: '/' },
  { name: 'Statistics', icon: FiTrendingUp, href: '/statistics' },
  { name: 'Content', icon: FiFilm, href: '/content' },
  { name: 'Upload', icon: FiUpload, href: '/upload' },
  { name: 'Settings', icon: FiSettings, href: '/settings' },
];

const SidebarContent = ({ onClose, ...rest }) => {
  
  return (
    <Box
      // transition="0.6s ease"
      bg={useColorModeValue('white', '#0b0b0b')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', '#0f0e0e')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      {...rest}
    >
      <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
        <Image
          src={useColorModeValue(
            require('./wipe-light.png'), // Light mode image
            require('./wipe-dark.png') // Dark mode image
          )} // Replace this path with the path to your image file
          alt="Wipe."
          boxSize="75px" // Adjust the size of the logo
          objectFit="contain" // Ensures the image scales nicely within its box
        />
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {LinkItems.map(link => (
        <NavItem
          onClick={onClose}
          //check prod later
          key={link.name}
          href={link.href}
          icon={link.icon}
        >
          {link.name}
        </NavItem>
      ))}
    </Box>
  );
};
const NavItem = ({ icon, children, href, ...rest }) => {
  
  const hoverColor = useColorModeValue('white', 'black');
  return (
    <Box
      as={RouterLink} // Use RouterLink for routing
      to={href} // Set the path to navigate
      style={{ textDecoration: 'none' }}
      _focus={{ boxShadow: 'none' }}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          bg: useColorModeValue('#1f1f1f', '#dedede'), // Light and dark mode hover backgrounds
          color: useColorModeValue('white', 'black'), // Text color on hover
        }}
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: hoverColor, // Use the hook result
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Box>
  );
};

const MobileNav = ({ onOpen, ...rest }) => {
  const navigate = useNavigate();

  const { toggleColorMode } = useColorMode();
  const text = useColorModeValue('dark', 'light');
  const SwitchIcon = useColorModeValue(FaMoon, FaSun);
  const [Username, setUsername] = React.useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        getUsername();

        //setVerify("none");
      } catch (error) {
        console.error(error);
      } finally {
        // setRefreshing(false); // Ensure refreshing is set to false after the data fetching
      }
    };

    fetchData();

    // Optionally return a cleanup function
    return () => {
      // cleanup logic if needed
    };
  }, []);

  const [followerCount, setFollowerCount] = React.useState('Loading...');
  const { logout } = useAuth();

  const getUsername = async () => {
    try {
      const token = await localStorage.getItem('accessToken');

      // Fetch the user's profile picture using the authentication token
      const response = await fetch('https://api.wipe.wtf/getUsername', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Check the content type to handle different types of responses
      const contentType = response.headers.get('content-type');

      let data;
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        // If the response is not JSON, read it as text
        const textData = await response.text();
        console.error('Expected JSON, received:', textData);
        throw new Error('Received non-JSON response');
      }

      if (response.status === 200) {
        setUsername(data);
        localStorage.setItem('logedinuser', data); // Ensure data is stored as a string
        console.log(data);
      } else {
        // Handle unexpected response status
        console.error('Unexpected response status:', response.status, data);
      }
    } catch (error) {
      console.error('Error fetching username:', error);
      console.log('mikeal we have a problem');
    }
  };

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      bg={useColorModeValue('white', '#0b0b0b')}
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}
    >
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="outline"
        aria-label="open menu"
        icon={<FiMenu />}
      />
      <Image
        display={{ base: 'flex', md: 'none' }}
        style={{ alignSelf: 'center' }}
        src={useColorModeValue(
          require('./wipe-light.png'), // Light mode image
          require('./wipe-dark.png') // Dark mode image
        )} // Replace this path with the path to your image file // Replace this path with the path to your image file
        alt="Wipe."
        boxSize="75px" // Adjust the size of the logo
        objectFit="contain" // Ensures the image scales nicely within its box
      />
      <IconButton
        display={{ base: 'none', md: 'flex' }}
        h="20"
        size="md"
        style={{ position: 'absolute', right: 180, height: 50 }}
        fontSize="lg"
        aria-label={`Switch to ${text} mode`}
        variant="ghost"
        _hover={{
          bg: useColorModeValue('white', 'gray.900'), // Light and dark mode hover backgrounds
          color: useColorModeValue('black', 'white'), // Text color on hover
        }}
        color="current"
        marginLeft="2"
        onClick={toggleColorMode}
        icon={<SwitchIcon />}
      />

      <HStack spacing={{ base: '0', md: '6' }}>
        <Flex alignItems={'center'}>
          <Menu>
            <MenuButton
              py={2}
              transition="all 0.3s"
              _focus={{ boxShadow: 'none' }}
            >
              <HStack>
                <Avatar
                  size={'sm'}
                  src={'https://api.wipe.wtf/profilepicturecontent/' + Username}
                />
                <VStack
                  display={{ base: 'none', md: 'flex' }}
                  alignItems="flex-start"
                  spacing="1px"
                  ml="2"
                >
                  <Text fontSize="sm" style={{ fontWeight: '700' }}>
                    {Username}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    Creator
                  </Text>
                </VStack>
                <Box display={{ base: 'none', md: 'flex' }}>
                  <FiChevronDown />
                </Box>
              </HStack>
            </MenuButton>
            <MenuList
              bg={useColorModeValue('white', 'gray.900')}
              borderColor={useColorModeValue('white', 'gray.700')}
            >
              <MenuItem onClick={()=>{navigate("/settings")}}>Settings</MenuItem>
             
             
              <MenuItem onClick={logout}> Logout</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </HStack>
    </Flex>
  );
};
const SidebarWithHeader = ({ children, useColorMode }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box minH="100vh" bg={useColorModeValue('white', '#0b0b0b')}>
      <SidebarContent
        onClose={onClose}
        display={{ base: 'none', md: 'block' }}
      />
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        returnFocusOnClose={false}
        onOverlayClick={onClose}
        size="full"
      >
        <DrawerContent>
          <SidebarContent onClose={onClose} />
        </DrawerContent>
      </Drawer>
      {/* Mobile navigation */}
      <MobileNav onOpen={onOpen} />
      <Box ml={{ base: 0, md: 60 }} p="4">
        {children}
      </Box>
    </Box>
  );
};

export default SidebarWithHeader;
